import React from "react";
import { Link } from "react-router-dom";
import styles from "./style/About.module.css";

const About = () => {
  return (
    <div className={styles.aboutContainer}>
      {/* HERO SECTION */}
      <div className={styles.hero}>
        <h1>About Book My Tuitions</h1>
        <p>
          Empowering students to find the right tutors and unlock their full
          potential through personalized learning.
        </p>
      </div>

      {/* CONTENT SECTION */}
      <div className={styles.content}>
        <div className={styles.card}>
          <h2>📚 Our journey</h2>
          <p>
            We have been on the education platform path since 2009, evolving with how families search
            for tutors, manage schedules, and stay involved in progress. That
            long runway shapes how we build trust, quality, and care into every
            connection on Book My Tuitions.
          </p>
        </div>

        <div className={styles.card}>
          <h2>🎯 Our Mission</h2>
          <p>
            To make quality education accessible, affordable, and personalized
            for every student across India.
          </p>
        </div>

        <div className={styles.card}>
          <h2>🚀 What We Do</h2>
          <p>
            We connect students with verified tutors for online learning with demo sessions and flexible plans.
          </p>
        </div>

        <div className={styles.card}>
          <h2>💡 Why Choose Us</h2>
          <p>
            Trusted by thousands of students, we provide easy tutor discovery,
            transparent pricing, and quality education support.
          </p>
        </div>
      </div>

      {/* STATS SECTION */}
      <div className={styles.stats}>
        <div>
          <h3>25K+</h3>
          <p>Students</p>
        </div>
        <div>
          <h3>5K+</h3>
          <p>Tutors</p>
        </div>
        <div>
          <h3>100+</h3>
          <p>Subjects</p>
        </div>
      </div>

      {/* CTA SECTION */}
      <div className={styles.cta}>
        <h2>Start Your Learning Journey Today</h2>

        <Link to="/signup-as-student" className={styles.navLink}>
          Find Tutors
        </Link>
      </div>
    </div>
  );
};

export default About;
